import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { ProdutoCatalogo } from '../../types/estoque';
import { catalogoProdutosService } from '../../services';

const columns: ResourceColumn<ProdutoCatalogo>[] = [
  { header: 'Código', accessor: 'codigo' },
  { header: 'Descrição', accessor: 'descricao' },
  { header: 'Tipo', accessor: 'tipo' },
  {
    header: 'Categoria',
    render: (item) => (item as any).categoria_produto_info ?? item.categoria_produto ?? '-',
  },
  {
    header: 'Unidade',
    render: (item) => (item as any).unidade_info ?? item.unidade ?? '-',
  },
  { header: 'Armazém', accessor: 'armazem' },
  { header: 'Localização', accessor: 'localizacao' },
  { header: 'Venda autorizada', render: (item) => (item.venda_autorizada ? 'Sim' : 'Não') },
];

export const ProdutosListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Produtos"
    description="Catálogo de produtos."
    columns={columns}
    service={catalogoProdutosService}
    createPath="/admin/cadastro/produtos/novo"
      onEdit={(item) => item.id && navigate(`/admin/cadastro/produtos/${item.id}`)}
  />
  );
};
